export { default as HomePage } from './HomePage';

export { default as Complete } from './Complete';

export { default as Declaration } from './Declaration';
export { default as Proposer } from './Proposer';
export { default as Vehicles } from './Vehicles';
export { default as Drivers } from './Drivers';
export { default as Quote } from './Quote';
export { default as Payment } from './Payment';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/index.ts